export function getSessionData(validFrom: string, validTill: string, sasExpiriesIn: string) {
  const session = `{
  "session_token": "HA3tkMmiyGrksPF3vPexK+Gp+plbnSf43OSLVS0XeTYCmwXurXV+KSENTP7+fTwgNURyJXEhQj8GtOnX25Yc6rENiIOWODqJBU4UAGB4Xvo19K2H/i1l0tpfKS3f550JczVVl0ORBXvz4LyOWR7p1nKq6fqrAUotGKVTC+L3EVl4eBpgvfC+YXOSn3aEo4zZqwOcJYXPdlXHvux2xC5Y3GBwQBJC9MDReoGXIcnXiOssC043uH5Mma1SVzp+0HKB1UI+nWffKx4JFXkjfcKovpUJEd/Aqpzxx21XnmtIrV6vUmrc3dzUAGOhZAycFDQpv3Akl4xJ/sv3fIXGlNVETN+uQ+Mt27i5kw1WGzF0X6UW50W0",
  "session_id": 297,
  "session_uuid": "185b92f5-d262-4956-b3dd-159757c07b21",
  "session_type": "live_proctor",
  "chat": {
    "token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoiMTAzODQtNDk1MC00NzcifQ.k6w-lbmcYPi41sT93O0HeW5AQcj5sbW-kIoK-GA4SwM",
    "user_id": "10384-4950-477"
  },
  "configuration": {
    "type": "live_proctor",
    "eye_gaze": false,
    "audio_call": true,
    "valid_from": "${validFrom}",
    "valid_till": "${validTill}",
    "audio_check": true,
    "screen_grab": true,
    "face_capture": false,
    "alert_configs": [
      {
        "id": 641,
        "name": "Unknown",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 1,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 642,
        "name": "Session Created",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 2,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 643,
        "name": "Session Joined",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 3,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 644,
        "name": "Window Focus-In",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 4,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 646,
        "name": "User Idle",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 6,
        "prompt_each_time": true,
        "prompt_min_occurrence": null
      },
      {
        "id": 647,
        "name": "User Active",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 7,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 648,
        "name": "Session Closed",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 8,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 649,
        "name": "Socket connection success",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 9,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 650,
        "name": "Socket disconnected",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 10,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 651,
        "name": "Screen-capture Started",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 11,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 652,
        "name": "Screen-capture Stopped",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 12,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 653,
        "name": "Recording Started",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 13,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 654,
        "name": "Recording Stopped",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 14,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 655,
        "name": "Face Detected",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 15,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 645,
        "name": "Window Focus-Out",
        "severity": "medium",
        "threshold": 2,
        "alert_type_id": 5,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 657,
        "name": "Notification Permission Granted",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 17,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 658,
        "name": "Notification Permission Denied",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 18,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 660,
        "name": "Screen-capture Install Failed",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 20,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 661,
        "name": "Screen-capture Screenshot",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 21,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 662,
        "name": "Camera Screenshot",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 22,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 663,
        "name": "Screen-capture Video",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 23,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 664,
        "name": "Camera Video",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 24,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 665,
        "name": "Face Detected Location",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 25,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 666,
        "name": "Camera Test Passed",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 26,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 667,
        "name": "Camera Test Failed",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 27,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 668,
        "name": "Microphone Test Passed",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 28,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 669,
        "name": "Microphone Test Failed",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 29,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 670,
        "name": "Network Test Passed",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 30,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 671,
        "name": "Network Test Failed",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 31,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 672,
        "name": "Id Submitted",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 32,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 673,
        "name": "Id Photo",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 33,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 676,
        "name": "Network Change",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 36,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 677,
        "name": "OS Change",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 37,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 678,
        "name": "Browser Change",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 38,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 679,
        "name": "Camera Audio",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 39,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 680,
        "name": "Speaker Recognized",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 40,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 681,
        "name": "Speaker Not Recognized",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 41,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 682,
        "name": "Face Recognized",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 42,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 683,
        "name": "Face Not Recognized",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 43,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 684,
        "name": "Face: Id - Session Matched",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 44,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 685,
        "name": "Face: Id - Session Not Matched",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 45,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 686,
        "name": "Face: Database Session Matched",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 46,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 687,
        "name": "Face: Database Session Not Matched",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 47,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 688,
        "name": "Emotion Change Detected",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 48,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 689,
        "name": "Object Detected",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 49,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 690,
        "name": "Voice Activity Started",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 50,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 691,
        "name": "Voice Activity Stopped",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 51,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 692,
        "name": "Illumination Level",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 52,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 693,
        "name": "Location Permission Granted",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 53,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 694,
        "name": "Location Permission Denied",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 54,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 695,
        "name": "Screen-capture Required",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 55,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 696,
        "name": "Screen-capture Installed",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 56,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 697,
        "name": "Browser Not Supported",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 57,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 698,
        "name": "Browser Supported",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 58,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 700,
        "name": "Camera Detected",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 60,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 701,
        "name": "Hardware Test Skipped",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 61,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 702,
        "name": "Forced",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 62,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 703,
        "name": "Detected",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 63,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 704,
        "name": "Not Detected",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 64,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 705,
        "name": "Network Connected",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 65,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 706,
        "name": "Camera Permission Granted",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 66,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 707,
        "name": "Camera Permission Denied",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 67,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 708,
        "name": "Microphone Permission Granted",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 68,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 709,
        "name": "Microphone Permission Denied",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 69,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 710,
        "name": "Hardware Test Passed",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 70,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 3059,
        "name": "Mobile Phone Detected",
        "severity": "high",
        "threshold": 2,
        "alert_type_id": 169,
        "prompt_each_time": true,
        "prompt_min_occurrence": null
      },
      {
        "id": 699,
        "name": "Camera Not Detected",
        "severity": "medium",
        "threshold": 2,
        "alert_type_id": 59,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 713,
        "name": "Face Detection Retried",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 73,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 715,
        "name": "Audio Test Failed",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 75,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 716,
        "name": "Audio Test Retried",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 76,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 3060,
        "name": "Book detected",
        "severity": "medium",
        "threshold": 3,
        "alert_type_id": 170,
        "prompt_each_time": true,
        "prompt_min_occurrence": null
      },
      {
        "id": 776,
        "name": "Precheck Approved",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 138,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 777,
        "name": "Precheck Rejected",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 139,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 778,
        "name": "Precheck Submitted",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 140,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 779,
        "name": "Precheck Pending",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 141,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 780,
        "name": "Session Playback Url",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 142,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 781,
        "name": "Live Proctor Screenshot",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 143,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 782,
        "name": "Session Terminated",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 144,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 783,
        "name": "Photo ID capture",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 145,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 784,
        "name": "Face capture",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 146,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 785,
        "name": "Screen Capture",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 147,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 786,
        "name": "Screen Capture Disabled",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 148,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 787,
        "name": "Screen Capture Enabled",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 149,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 721,
        "name": "Multiple Face Detected",
        "severity": "critical",
        "threshold": 1,
        "alert_type_id": 81,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 719,
        "name": "Network Lost",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 79,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 720,
        "name": "Network Reconnected",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 80,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 722,
        "name": "Text Copied",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 82,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 723,
        "name": "Contextmenu Clicked",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 83,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 724,
        "name": "Context Switched",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 84,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 725,
        "name": "Print Screen Clicked",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 85,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 726,
        "name": "Custom Event",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 87,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 727,
        "name": "Android: Screenshot",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 88,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 728,
        "name": "Android: Pause",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 89,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 729,
        "name": "Android: Resume",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 90,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 730,
        "name": "Android: Incoming Call",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 91,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 731,
        "name": "Android: Battery Low",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 92,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 732,
        "name": "Android: Battery Okay",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 93,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 733,
        "name": "Android: Proview Stop",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 94,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 734,
        "name": "Android: Proview Start",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 95,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 735,
        "name": "Android: Proview Start Fail",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 96,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 736,
        "name": "Android: Raw Video",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 97,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 737,
        "name": "Android: Network Disconnect",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 98,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 738,
        "name": "Android: Network Reconnect",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 99,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 739,
        "name": "iOS: Network Reconnect",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 100,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 740,
        "name": "iOS: Network Disconnect",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 101,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 741,
        "name": "iOS: Raw Video",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 102,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 742,
        "name": "iOS: Proview Start Fail",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 103,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 743,
        "name": "iOS: Proview Start",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 104,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 744,
        "name": "iOS: Proview Stop",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 105,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 745,
        "name": "iOS: Battery Okay",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 106,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 746,
        "name": "iOS: Battery Low",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 107,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 747,
        "name": "iOS: Incoming Call",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 108,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 748,
        "name": "iOS: Resume",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 109,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 749,
        "name": "iOS: Pause",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 110,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 750,
        "name": "iOS: Screenshot",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 111,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 751,
        "name": "WebRTC Video File",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 112,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 752,
        "name": "Session Completed",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 113,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 753,
        "name": "Photo Enrollment",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 114,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 754,
        "name": "Voice Enrollment 1",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 115,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 755,
        "name": "Voice Enrollment 2",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 116,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 756,
        "name": "Voice Enrollment 3",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 117,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 757,
        "name": "Photo Id Enrollment",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 118,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 758,
        "name": "Photo Fingerprint Check Request",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 119,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 759,
        "name": "Photo Fingerprint Check Success",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 120,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 760,
        "name": "Photo Fingerprint Check Failed",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 121,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 761,
        "name": "Voice Fingerprint Check Request",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 122,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 762,
        "name": "Voice Fingerprint Check Success",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 123,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 763,
        "name": "Voice Fingerprint Check Failed",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 124,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 764,
        "name": "Face Verification Check Request",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 125,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 765,
        "name": "Face Verification Check Success",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 126,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 766,
        "name": "Face Verification Check Failed",
        "severity": "critical",
        "threshold": 0,
        "alert_type_id": 127,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 768,
        "name": "Voice detected",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 129,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 770,
        "name": "Microphone switched",
        "severity": "medium",
        "threshold": 2,
        "alert_type_id": 131,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 771,
        "name": "Microphone not detected",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 132,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 772,
        "name": "Test Environment Check",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 133,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 773,
        "name": "Test Environment Camera Video",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 134,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 774,
        "name": "Proctor Rating Override",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 136,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 788,
        "name": "Screen Capture Denied",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 150,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 789,
        "name": "Cron Job Session Completed",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 151,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 790,
        "name": "Partial Screen Sharing Permitted",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 152,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 791,
        "name": "Full Screen Sharing Permitted",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 153,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 792,
        "name": "Face capture Success",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 154,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 793,
        "name": "Face capture Failure",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 155,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 794,
        "name": "ID card capture success",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 156,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 795,
        "name": "ID card capture failure",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 157,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 796,
        "name": "Socket connection failure",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 158,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 797,
        "name": "Audio device detected",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 159,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 798,
        "name": "Audio device not detected",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 160,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 799,
        "name": "Environment test capture success",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 161,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 800,
        "name": "Environment test capture failure",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 162,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 801,
        "name": "Photo ID card Not Available",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 163,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 802,
        "name": "Gazing away",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 164,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 803,
        "name": "Eye detected",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 165,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 804,
        "name": "Eye not detected",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 166,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 805,
        "name": "Src Photo Id Card Not Available",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 167,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 806,
        "name": "Src Face Not Available",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 168,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 769,
        "name": "Camera switched",
        "severity": "medium",
        "threshold": 2,
        "alert_type_id": 130,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 767,
        "name": "Pasting text detected",
        "severity": "low",
        "threshold": 1,
        "alert_type_id": 128,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 4360,
        "name": "Face Not Detected",
        "severity": "high",
        "threshold": 3,
        "alert_type_id": 16,
        "prompt_each_time": true,
        "prompt_min_occurrence": null
      },
      {
        "id": 4364,
        "name": "Audio Call Requested",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 172,
        "prompt_each_time": false,
        "prompt_min_occurrence": 1
      },
      {
        "id": 4368,
        "name": "Audio Call Initiated",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 173,
        "prompt_each_time": false,
        "prompt_min_occurrence": 1
      },
      {
        "id": 4372,
        "name": "Audio Call Connected",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 174,
        "prompt_each_time": false,
        "prompt_min_occurrence": 1
      },
      {
        "id": 4376,
        "name": "Audio Call Progress",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 175,
        "prompt_each_time": false,
        "prompt_min_occurrence": 1
      },
      {
        "id": 4380,
        "name": "Audio Call Ended",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 176,
        "prompt_each_time": false,
        "prompt_min_occurrence": 1
      },
      {
        "id": 4384,
        "name": "Audio Test Passed",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 74,
        "prompt_each_time": false,
        "prompt_min_occurrence": null
      },
      {
        "id": 4400,
        "name": "File Upload Failure",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 179,
        "prompt_each_time": false,
        "prompt_min_occurrence": 1
      },
      {
        "id": 4404,
        "name": "Audio Recorded",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 180,
        "prompt_each_time": false,
        "prompt_min_occurrence": 1
      },
      {
        "id": 4412,
        "name": "Candidate Offline",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 181,
        "prompt_each_time": false,
        "prompt_min_occurrence": 1
      },
      {
        "id": 4426,
        "name": "Midway Check Retry",
        "severity": "none",
        "threshold": null,
        "alert_type_id": 182,
        "prompt_each_time": false,
        "prompt_min_occurrence": 1
      }
    ],
    "end_buffer_time": 0,
    "video_recording": true,
    "object_detection": false,
    "twilio_streaming": true,
    "environment_check": true,
    "start_buffer_time": 0,
    "chat_support_event": true,
    "mixpanel_analytics": true,
    "pre_flight_approval": true,
    "terms_and_conditions": true,
    "chat_support_precheck": true,
    "high_touch_proctoring": true,
    "id_verification_check": true,
    "midway_face_verification": true,
    "is_alvy_id_check_ai_rnr_enabled": false
  },
  "instruction": "<p>dsfdffffsdfd</p>",
  "storage": {
    "service": "azure",
    "sas_token": "sv=2021-06-08&si=10972&sr=c&sig=tFsAUzHKjZyEeFh92wBemRRCod5ROYlcsx9tNkDBg6I%3D",
    "sas_expiries_in": "${sasExpiriesIn}",
    "sas_url": "http://localhost:8080/",
    "container_name": "185b92f5-d262-4956-b3dd-159757c07b21",
    "file_destination": {
      "screen_grab": "147",
      "camera_grab": "143",
      "test_env": "133",
      "video": "112/raw"
    }
  },
  "identification": {
    "photo_id": false,
    "photo": false
  },
  "organization_id": 31
}`;

  return session;
}
